import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  
  // Get the main Nodesail URL from environment variable or use a default
  const MAIN_NODESAIL_URL = process.env.REACT_APP_MAIN_NODESAIL_URL || 'https://nodesail.com';
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            <div className="copyright-text">
              &copy; {year} Nodesail. Old Satkhira Road, Khulna, KH 9253, Bangladesh
            </div>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <div className="footer-links">
              <a href="https://nodesail.com/terms" className="footer-link" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>
              <a href="https://nodesail.com/privacy" className="footer-link" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              <a href={`${MAIN_NODESAIL_URL}/cookie`} className="footer-link" target="_blank" rel="noopener noreferrer">
                Cookie Policy
              </a>
              <a href="https://community.nodesail.com" className="footer-link" target="_blank" rel="noopener noreferrer">
                Community
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;